export default "__VITE_ASSET__3ccc6102__"